/** Where calendar-linked clients open in the CCC app. */
export type CccClientType = 'none' | 'recuperacao' | 'prospeccao' | 'retencao' | 'resolucao';

export const CCC_CLIENT_TYPE_LABELS: Record<CccClientType, string> = {
  none: 'Sem cliente',
  recuperacao: 'Recuperação',
  prospeccao: 'Prospeção',
  retencao: 'Reposição',
  resolucao: 'Resolução',
};

export const CCC_CLIENT_TYPE_COLORS: Record<CccClientType, string> = {
  none: '#64748b',
  recuperacao: '#e6001a',
  prospeccao: '#2563eb',
  retencao: '#8b5cf6',
  resolucao: '#059669',
};

export function clientRoutePath(type: CccClientType): string {
  switch (type) {
    case 'recuperacao':
      return '/recuperacao';
    case 'prospeccao':
      return '/prospeccao';
    case 'retencao':
      return '/retencao';
    case 'resolucao':
      return '/resolucao';
    default:
      return '/';
  }
}

export function buildClientNavigateUrl(type: CccClientType, ref?: string | null): string {
  const base = clientRoutePath(type);
  if (!ref || type === 'none') return base;
  if (type === 'recuperacao' || type === 'retencao') {
    return `${base}?marcacao=${encodeURIComponent(ref)}`;
  }
  return `${base}?ref=${encodeURIComponent(ref)}`;
}

/** Open a CCC client workspace with the Histórico tab selected (Gerente/Admin). */
export function buildClientHistoricoUrl(
  type: Exclude<CccClientType, 'none' | 'resolucao'>,
  ref: string
): string {
  const base = buildClientNavigateUrl(type, ref);
  const sep = base.includes('?') ? '&' : '?';
  return `${base}${sep}tab=historico`;
}
